import Shepherd from 'shepherd.js';

if($('.application-review-page').length && $('.application-draft').length){
    
    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'application-review'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    if($(window).width() < 992){
        var attachTo = {
            element: '.dashboard-title-wrapper .dashboard-sidebar-toggle',
            on: 'bottom'
        }
    }else{
        var attachTo = {
            element: '.dashboard--sidebar .nav--dashboard ul',
            on: 'right'
        }
    }
    
    tour.addStep({
        title: 'Review your Application',
        text: "Your application is still in draft and we want you to have a final review before submitting it. Use the buttons in the boxed sections to go back and edit any part of your application.",
        // attachTo: {
        //     element: '.dashboard--overview',
        //     on: 'bottom-start'
        // },
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: "Submit your Application",
        text: "Once you're finished you can click this button to submit your application to the Challenge. Alternatively, if you wish to come back later, you will be able to access your innovation via your dashboard.",
        attachTo: {
            element: '.submit-application .btn',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    window.scrollTo(0, 0);
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: "What happens next?",
        text: "Once you've finished, you can click this button to 'Submit your Application' to the Challenge. Alternatively, if you wish to come back later, you will be able to access your innovation application via the dashboard under 'Applications'.",
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-3'
    });

    $('.replay-onboarding').show();

    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if($('.application-review-page').length && $('.application-draft').length && !$('.onboarding-application-review').length){
        tour.start();
    }
}
